import { render, staticRenderFns } from "./grouping.vue?vue&type=template&id=f9d641b6&scoped=true"
import script from "./grouping.vue?vue&type=script&lang=js"
export * from "./grouping.vue?vue&type=script&lang=js"
import style0 from "./grouping.vue?vue&type=style&index=0&id=f9d641b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d641b6",
  null
  
)

export default component.exports